import { combineReducers } from 'redux';

import * as actions from '../actions/ActionTypes';

const initialState = {
  errorBoundary: {
    display: false,
  },
  errorApi: {
    display: false,
  },
};

/**
 * Client error reducer
 * @param state
 * @param action
 * @return {*}
 */
const errorBoundary = (state = initialState.errorBoundary, action) => {
  switch (action.type) {
    case actions.HANDLE_ERROR_BOUNDARY:
      return {
        ...state,
        display: true,
        userAgent: action.userAgent,
        ...action.error,
      };
    default:
      return state;
  }
};

/**
 * API error reducer, handle only with actions that include '/error'
 * @param state
 * @param action
 * @return {*}
 */
const errorApi = (state = initialState.errorApi, action) => {
  if (action.type.includes(actions.error)) {
    return {
      ...state,
      display: true,
      ...action.error,
    };
  }
  return state;
};

export default combineReducers({
  errorBoundary,
  errorApi,
});
